module.exports = __webpack_public_path__ + "static/media/overpass-light.f3914c0c.ttf";